/**
 * P1-1 (DCTA-192, polish audit): the chat's stream across a re-attach. Leaving the chat for another screen takes its nodes
 * out of the page; putting them back started the scroller at 0 (the OLDEST message, 0 of 3,076 px measured) and restarted
 * every entrance animation (`vault-rise` on each `.enter`) — the whole conversation rose again, turn by turn.
 *
 * Leaving keeps the place — the newest line, or where the customer had scrolled to — and takes the entrance off everything
 * already shown (it rose once); coming back restores the place. Presentation only.
 */
interface Place {
  readonly top: number;
  readonly atEnd: boolean;
}

const places = new WeakMap<HTMLElement, Place>();

/** At its newest line: within a few pixels of the end, as the chat's own dock padding counts it (ui/chat.ts). */
const AT_END_PX = 4;

export function leaveStream(body: HTMLElement): void {
  places.set(body, { top: body.scrollTop, atEnd: body.scrollHeight - body.scrollTop - body.clientHeight <= AT_END_PX });
  for (const node of body.querySelectorAll(".enter")) node.classList.remove("enter");
}

export function returnToStream(body: HTMLElement): void {
  const place = places.get(body);
  body.scrollTop = place === undefined || place.atEnd ? body.scrollHeight : place.top;
}
